import { render, staticRenderFns } from "./ClientIPRs.vue?vue&type=template&id=0888098a"
import script from "./ClientIPRs.vue?vue&type=script&lang=js"
export * from "./ClientIPRs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports